import { render } from "./DSSProjects.vue?vue&type=template&id=502bbf58&scoped=true"
import script from "./DSSProjects.vue?vue&type=script&lang=js"
export * from "./DSSProjects.vue?vue&type=script&lang=js"

import "./DSSProjects.vue?vue&type=style&index=0&id=502bbf58&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502bbf58"]])

export default __exports__